module.exports = __webpack_public_path__ + "static/img/logo_SZ.672fd655.png";